import React, { useState, useEffect } from "react";
import SearchModal from './SearchModal';

export default function Chatbot()  {
    const [showModal, setShowModal] = useState(false);
  
    const handleImageClick = () => {
      setShowModal(true);
    };
  
    const handleCloseModal = () => {
      setShowModal(false);
    };
  
    return (
      <div>
        <img
          src="https://jharkhandtest.schoolnetindia.com/assets/adminassests/media/chatbot/Bot-new-icon.svg"
          alt="Click to open modal"
          width={36}
          height={36}
          onClick={handleImageClick}
          style={{ cursor: 'pointer', position: 'fixed',
            bottom: '75px',
            right: '10px',
            cursor: 'pointer',
            backgroundColor: '#007bff',
            borderRadius: '50%',
            padding: '1px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
            color: 'white', }}
        />
        <SearchModal show={showModal} handleClose={handleCloseModal} />
      </div>
    );
  };
